// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./scss/mbstalas.scss
// module id = 1306
// module chunks = 146